<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-title />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-categories-card />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-content />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <corporate-policies-ordering-card />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import CorporatePoliciesTitle from '@/views/Admin/Corporate_policies/Elements/TitleCard.vue'
import CorporatePoliciesContent from '@/views/Admin/Corporate_policies/Elements/ContentsCard.vue'
import CorporatePoliciesCategoriesCard
from '@/views/Admin/Corporate_policies/Elements/CorporatePoliciesCategoriesCard.vue'
import CorporatePoliciesOrderingCard from '@/views/Admin/Corporate_policies/Elements/OrderingCard.vue'

export default {
  name: 'CorporatePoliciesStandartForm',
  components: {
    CorporatePoliciesOrderingCard,
    CorporatePoliciesCategoriesCard,
    CorporatePoliciesContent,
    CorporatePoliciesTitle,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['corporatePolicies/dataItem']
    },
  },
}
</script>
